(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('delivery-status', {
            parent: 'entity',
            url: '/delivery-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_status.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-status/delivery-statuses.html',
                    controller: 'Delivery_statusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('delivery-status-detail', {
            parent: 'delivery-status',
            url: '/delivery-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_status.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-status/delivery-status-detail.html',
                    controller: 'Delivery_statusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Delivery_status', function($stateParams, Delivery_status) {
                    return Delivery_status.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'delivery-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('delivery-status-detail.edit', {
            parent: 'delivery-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-status/delivery-status-dialog.html',
                    controller: 'Delivery_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_status', function(Delivery_status) {
                            return Delivery_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-status.new', {
            parent: 'delivery-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-status/delivery-status-dialog.html',
                    controller: 'Delivery_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('delivery-status', null, { reload: 'delivery-status' });
                }, function() {
                    $state.go('delivery-status');
                });
            }]
        })
        .state('delivery-status.edit', {
            parent: 'delivery-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-status/delivery-status-dialog.html',
                    controller: 'Delivery_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_status', function(Delivery_status) {
                            return Delivery_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-status', null, { reload: 'delivery-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-status.delete', {
            parent: 'delivery-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-status/delivery-status-delete-dialog.html',
                    controller: 'Delivery_statusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Delivery_status', function(Delivery_status) {
                            return Delivery_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-status', null, { reload: 'delivery-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
